import React, { useState, useEffect } from "react";
import {
  Typography,
  makeStyles,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  Paper,
  TableHead,
  TableRow,
  Grid,
} from "@material-ui/core";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import { useHistory } from "react-router-dom";

import Loader from "../../components/Loader";
import axios from "axios";

import { STORAGE_SUPERVISOR } from "../../configs/urls";

import { getApi } from "../../services/api";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    maxWidth: 752,
    minWidth: "100%",
    margin: "auto",
  },
  demo: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: 10,
  },
  title: {
    margin: theme.spacing(4, 0, 2),
  },
  listContainer: {
    width: "100%",
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  clearAllButton: {
    minWidth: "130px !important",
    paddingLeft: 8,
    paddingRight: 8,
    marginTop: 10,
    paddingBottom: 3,
    marginLeft: 20,
  },
}));

export default function DieselSupervisors(props) {
  const classes = useStyles();
  const [supervisorList, setStorageSupervisors] = useState([]);
  const history = useHistory();
  const [isRequesting, setIsRequestig] = useState(false);
  const [params, setParams] = useState({});

  useEffect(() => {
    getAllData();
  }, []); //eslint-disable-line

  const getAllData = () => {
    setIsRequestig(true);
    const supervisors = getApi(STORAGE_SUPERVISOR);

    axios
      .all([supervisors])
      .then((res) => {
        if (res[0] && res[0].data) {
          setStorageSupervisors(res[0].data);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsRequestig(false);
      });
  };

  const renderList = () => (
    <>
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="caption table">
          <TableHead>
            <TableRow>
              <TableCell>Sr. No.</TableCell>
              <TableCell align="center">Farmer</TableCell>
              <TableCell align="center">Farm</TableCell>
              <TableCell align="center">Team</TableCell>
              <TableCell align="center">Project</TableCell>
              <TableCell align="center">Bails Received</TableCell>
              <TableCell align="center">Weight</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {supervisorList.map((item, idx) => (
              <TableRow key={idx}>
                <TableCell component="th" scope="row">
                  {idx + 1}
                </TableCell>
                <TableCell align="center" component="th" scope="row">
                  {item?.farmer?.name || "--"}
                </TableCell>
                <TableCell align="center" component="th" scope="row">
                  {item?.farm?.area || "--"}
                </TableCell>
                <TableCell align="center" component="th" scope="row">
                  {item?.team?.name || "--"}
                </TableCell>
                <TableCell align="center" component="th" scope="row">
                  {item?.project?.name || "--"}
                </TableCell>
                <TableCell align="center">
                  {item.bails_received || "N/A"}
                </TableCell>
                <TableCell align="center">{item.weight || "N/A"}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
  return (
    <div className={classes.root}>
      <Loader isLoading={isRequesting} />
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Grid
            container
            direction="row"
            justify="space-between"
            alignItems="center"
          >
            <Typography variant="h6" className={classes.title}>
              Storage Supervisors
            </Typography>
          </Grid>
          {supervisorList.length ? (
            renderList()
          ) : (
            <Box
              fontSize="h6.fontSize"
              m={1}
              p={{ xs: 2, sm: 2, md: 2 }}
              style={{ textAlign: "center" }}
            >
              No Records found.
            </Box>
          )}
        </GridItem>
      </GridContainer>
    </div>
  );
}
